<script>
import throttle from 'lodash/throttle';
import ResizeObserver from 'resize-observer-polyfill';

/**
 * This is a wrapper component that determines the size of a wrapper component. This can be used for localized breakpoints.
 * think of this as window.resize for elements.
 */
export default {
  name: 'ResizeObserver',
  props: {
    /**
     * This is an object of functions that are used to determine what breakpoints are active on the component.
     */
    breakpoints: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: [
    /**
    * Emitted with the element size info when resized after mounting on DOM
    */
    'onResize',
  ],
  data: () => ({
    el: {
      width: 0,
      height: 0,
      is: {},
      observer: null,
    },
  }),
  mounted() {
    if (this.breakpoints) {
      this.$nextTick(() => {
        const handleResize = throttle((entries) => {
          const cr = entries[0].contentRect;
          this.el.width = cr.width;
          this.el.height = cr.height;
          const conds = { ...this.breakpoints || {} };
          // eslint-disable-next-line no-restricted-syntax, guard-for-in
          for (const breakpoint in conds) {
            this.el.is[breakpoint] = conds[breakpoint](this.el);
          }
          this.$emit('onResize', this.el.is);
        }, 500);

        this.observer = new ResizeObserver(handleResize);
        if (this.$el instanceof Element) this.observer?.observe(this.$el);
        // could be a <template>
        if (this.$el instanceof Text) this.observer?.observe(this.$el.nextSibling);
      });
    }
  },
  unmounted() {
    this.observer.disconnect();
  },
  render() {
    // try {
    return this.$slots.default({ el: this.el });
    // } catch (e) {
    // throw new Error(`${'ResizeObserver.vue can only render one, and exactly one child component.\r\n'}${e}`);
    // }
  },
};
</script>
